import { Stack, styled } from '@mui/material';

const GuidelinesPanel = styled(Stack)(({ theme }) => ({
	borderTop: `1px solid ${theme.palette.divider}`,
	marginTop: theme.spacing(2.5),
	paddingTop: theme.spacing(2.5),

	[theme.breakpoints.down('md')]: {
		marginTop: theme.spacing(2),
		paddingTop: theme.spacing(2),
	}
}))

export default GuidelinesPanel;
